import { apiClient, FeatureMap } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const createClient = async (clientData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/clients/create", clientData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateClient = async (
  id: string,
  clientData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/users/edit/${id}`, clientData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteClient = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/allusers/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};


//for profile update and view + change pass
export interface MyProfile {
  id: string;
  organizationId: string;
  fullName: string;
  phone: string | null;
  country: string | null;
  banner: string | null;
  active: boolean;
  role: string | null;
  email: string | null;
  /** Per-organization feature switches. All keys are always present. */
  features?: FeatureMap;
}

export interface UpdateProfilePayload {
  full_name?: string;
  email?: string;
  phone?: string;
  country?: string;
  banner?: string;
}

export interface ChangePasswordPayload {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
  logoutAllDevices: boolean;
}

export interface ChangePasswordResponse {
  message: string;
  loggedOutAllDevices: boolean;
}

export const getMyProfile = async (): Promise<MyProfile> => {
  const res = await apiClient.get<MyProfile>("/auth/me");
  return res.data;
};


export const updateMyProfile = async (
  payload: UpdateProfilePayload,
  bannerFile?: File
): Promise<MyProfile> => {
  const form = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      form.append(key, value);
    }
  });

  if (bannerFile) {
    form.append("banner", bannerFile);
  }

  const res = await apiClient.patch<MyProfile>("/auth/me/update", form, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};

export const changePassword = async (
  payload: ChangePasswordPayload
): Promise<ChangePasswordResponse> => {
  const res = await apiClient.post<ChangePasswordResponse>("/auth/change-password", payload);
  return res.data;
};
